<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
export default {
  name: "print-cart",
  methods: {
    resetTabPrint() {
      this.$store.dispatch("sale/setTabLoading", false);
      this.$store.dispatch("sale/setTabPrint", false);
      setTimeout(() => {
        this.$store.dispatch("sale/resetTab");
      }, 100);
    },
    getDate: function() {
      return this.moment().format("DD/MM/YYYY HH:MM");
    },
    itemTotal: function(data) {
      return (data.cost - (data.discount * data.cost) / 100) * data.amount;
    },
    print: function() {
      let html = this.$refs.print_content.innerHTML;
      let printView = window.document.getElementById("printer-view");
      printView.innerHTML = html;
      window.print();
    },
  },
  mounted: function() {
    setTimeout(() => {
      this.print();
    }, 500);
  },
  computed: {
    orderNote: {
      get: function() {
        return this.$store.getters["sale/orderNote"];
      },
      set: function(value) {
        this.$store.dispatch("setOrderNote", value);
      },
    },
    paymentPaid: function() {
      if (this.currentTab.products.length < 1) return [];
      let paymentPaid = JSON.parse(
        JSON.stringify(this.currentTab.info.payment)
      );
      return paymentPaid.filter(function(item) {
        if (item.value > 0) {
          var arr = item.journal_name.split(" - ");
          item.nameshow = arr.length > 1 ? arr[1] : item.journal_type;
          return item;
        }
      });
    },

    totalEbill: function() {
      return this.$store.getters["sale/totalEbill"];
    },
    returnAmount: function() {

      var returnAmount = this.currentTab.info.returnAmount + this.totalEbill;
      if(returnAmount < 0) returnAmount = 0;
      return returnAmount;
    },
    currentUser: function() {
      return this.$store.getters["auth/currentUser"];
    },
    noti: function() {
      let arr = this.$store.getters["sale/noti"];
      if (typeof arr == "undefined" || !arr || arr.length < 1) return [];
      return JSON.parse(JSON.stringify(arr)).reverse();
    },
    tabs: function() {
      return this.$store.getters["sale/tabs"];
    },
    currentTab: function() {
      return this.$store.getters["sale/currentTab"];
    },
    nvbh: function() {
      let currentTab = this.$store.getters["sale/currentTab"];
      return typeof currentTab.info != "undefined" &&
        typeof currentTab.info.nvbh != "undefined" &&
        typeof currentTab.info.nvbh.name != "undefined"
        ? currentTab.info.nvbh.name
        : "";
    },
    totalPayment: function() {
      return this.$store.getters["sale/totalPayment"];
    },
    sessionID: function() {
      return this.$store.getters["sale/sessionID"];
    },
    posID: function() {
      let posID = this.$store.getters["sale/posID"];
      return typeof posID != "undefined" && typeof posID.pos_id != "undefined"
        ? posID.pos_id
        : 0;
    },
    posName: function() {
      let posID = this.$store.getters["sale/posID"];
      return typeof posID != "undefined" && typeof posID.pos_name != "undefined"
        ? posID.pos_name
        : "TGA POS";
    },
    customer: function() {
      let customer = this.$store.getters["sale/customer"];
      return typeof customer != "undefined" && typeof customer.id != "undefined"
        ? customer
        : false;
    },
    customerName: function() {
      let customer = this.$store.getters["sale/customer"];
      return typeof customer != "undefined" &&
        typeof customer.name != "undefined"
        ? customer.name
        : "";
    },
    voucher: function() {
      return this.$store.getters["sale/voucher"];
    },
    district: function() {
      return this.$store.getters["sale/sesdistrictsionID"];
    },
    province: function() {
      return this.$store.getters["sale/province"];
    },
    cashier: function() {
      return this.$store.getters["sale/cashier"];
    },
    paymentMethod: function() {
      return this.$store.getters["sale/paymentMethod"];
    },
  },
};
</script>
<template>
  <div class="receipt-print">
    <div class="receipt-print-header text-center">
      <button class="print-button btn btn-secondary" @click="print"><i class="bx bx-printer"></i> In hóa đơn</button><button class="btn btn-primary" @click="resetTabPrint">Đơn hàng kế tiếp</button>
    </div>
    <div class="print-content" ref="print_content">
      <div v-if="posID == 174">
        <div style="text-align: center"><img src="https://mia.vn/media/images/logo-herschel-2.jpg" alt="" style="height: 90px;"></div>
        <p style="text-align: center;padding: 5px 0px; font-size: 0.9em">https://mia.vn/herschel</p>
      </div>
      <div v-else>
        <h1 style="padding-top:0px; margin:0px; padding-bottom:0px; text-align:center; font-size:20px; font-weight: bold;text-transform: uppercase;" >{{ posName }}</h1>
        <p style="text-align:center;">www.mia.vn</p>
      </div>
      <p style="text-align:center; border-bottom: 1px dashed #000; padding-bottom: 10px;" >{{ currentUser.address }}</p>
      <h1 style="padding-top:10px; margin:0px; padding-bottom:5px; text-align:center; font-size:20px; font-weight: bold;">PHIẾU THANH TOÁN</h1>
      <div class="flex-row">
        <div class="col-left">Thời gian:</div>
        <div class="col-right">{{ getDate() }}</div>
      </div>
      <div class="flex-row">
        <div class="col-left">Khách hàng:</div>
        <div class="col-right">
          <span
            ><b>{{ currentTab.info.customer.name }}</b> -
            {{ currentTab.info.customer.phone }}</span
          >
        </div>
      </div>
      <div class="flex-row">
        <div class="col-left">NVBH:</div>
        <div class="col-right">{{ currentTab.info.nvbh.name }}</div>
      </div>
      <div class="flex-row">
        <div class="col-left">Thu ngân:</div>
        <div class="col-right">{{ currentUser.name }}</div>
      </div>
      <ul
        style="padding:5px 0px; padding-left:10px; line-height:20px; border-top:2px solid #000; border-bottom:2px solid #000; margin:3px 0px 10px !important"
      >
        <li
          style="margin-top:5px"
          v-for="item in currentTab.products"
          :key="item.id"
          :value="item"
        >
          {{ item.name }} <br />{{ item.serials.length }} x
          {{ item.cost | VND }}₫
          <span v-if="item.discount > 0"> - {{ item.discount }}%</span>
          <span style="display:inline-block; float:right;font-weight:bold"
            >= {{ itemTotal(item) | VND }} <sup>₫</sup></span
          >
        </li>
        <li
          v-if="
            currentTab.info.voucherDiscount &&
              currentTab.info.voucherDiscount > 0
          "
        >
          Giảm voucher:
          <span style="display:inline-block; float:right;font-weight:bold"
            >-{{ currentTab.info.voucherDiscount | VND }} <sup>₫</sup></span
          >
        </li>
        <li
          v-if="
            currentTab.info.otherDiscount && currentTab.info.otherDiscount > 0
          "
        >
          Giảm khác:
          <span style="display:inline-block; float:right;font-weight:bold"
            >-{{ currentTab.info.otherDiscount | VND }} <sup>₫</sup></span
          >
        </li>
        <li
          v-if="
            currentTab.info.customerDiscountValue &&
              currentTab.info.customerDiscountValue > 0
          "
        >
          Giảm thành viên:
          <span style="display:inline-block; float:right;font-weight:bold"
            >-{{ currentTab.info.customerDiscountValue | VND }}
            <sup>₫</sup></span
          >
        </li><li
          v-if="
            currentTab.info.transportFee && currentTab.info.transportFee > 0
          "
        >
          Phí vận chuyển:
          <span style="display:inline-block; float:right;font-weight:bold"
            >{{ currentTab.info.transportFee | VND }} <sup>₫</sup></span
          >
        </li>
      </ul>
      <div class="flex-row bold-text">
        <div class="col-left">Thành tiền:</div>
        <div class="col-right">
          <span>{{ currentTab.info.totalAmount | VND }} <sup>₫</sup></span>
        </div>
      </div>
      <div class="flex-row bold-text">
        <div class="col-left">Khách thanh toán:</div>
        <div class="col-right">
          <span>{{ (totalPayment + totalEbill) | VND }} <sup>₫</sup></span>
        </div>
      </div>
      <div style="padding-left: 15px;">
        <div
          class="flex-row"
          v-for="(item, index) in paymentPaid"
          :key="index"
          :value="item"
        >
          <div class="col-left">{{ item.nameshow }}:</div>
          <div class="col-right">
            <span>{{ item.value | VND }} <sup>₫</sup></span>
          </div>
        </div>
        <div class="flex-row" v-id="totalEbill > 0">
          <div class="col-left">eBill:</div>
          <div class="col-right">
            <span>{{ totalEbill | VND }} <sup>₫</sup></span>
          </div>
        </div>
      </div>
      <div
        class="flex-row bold-text"
        style="border-bottom: 2px solid #000;margin-bottom: 10px;padding-bottom: 10px"
      >
        <div class="col-left">Tiền thừa:</div>
        <div class="col-right">
          <span>{{ returnAmount | VND }} <sup>₫</sup></span>
        </div>
      </div>
      <p style="margin-bottom:3px">- Chỉ xuất hóa đơn đỏ trong ngày.</p>
      <p style="margin-bottom:3px">
        - Đổi hàng trong 365 ngày trên toàn hệ thống.
      </p>
      <p style="margin-bottom:3px">
        - Bảo hành theo số điện thoại cung cấp trên hóa đơn.
      </p>
      <p>
        <br />Hỗ trợ sản phẩm và dịch vụ:
        <b style="font-size:18px">1800 6198</b>
      </p>
      <p
        style="text-align:center; font-style: italic; padding-top: 15px;margin-bottom: 0px !important;padding-bottom: 5px;"
      >
        Xin cám ơn quý khách. Hẹn gặp lại!
      </p>
      <div class="text-center">---</div>
    </div>
  </div>
</template>
